'use client';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, ReferenceLine } from 'recharts';
import type { VelocityRow } from '@/lib/research/types';

interface Props {
  trajectory: VelocityRow['trajectory'];
}

const COLORS = {
  q: '#60a5fa',          // blue (matches Quality elsewhere)
  v: '#4ade80',          // green (matches Valuation elsewhere)
  composite: '#f59e0b',  // amber (composite gold)
};

export function TrajectoryChart({ trajectory }: Props) {
  // Recharts wants a flat array of data points
  const data = trajectory.map(t => ({
    date: t.date.slice(5), // MM-DD
    Q: t.q,
    V: t.v,
    Composite: t.composite,
  }));

  return (
    <div className="w-full h-48">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -16 }}>
          <CartesianGrid strokeDasharray="2 2" stroke="#1e293b" />
          <XAxis dataKey="date" stroke="#64748b" fontSize={10} tickLine={false} />
          <YAxis stroke="#64748b" fontSize={10} tickLine={false} domain={['auto', 'auto']} />
          <ReferenceLine y={0} stroke="#334155" />
          <Tooltip
            contentStyle={{ background: '#0d1117', border: '1px solid #1e293b', borderRadius: 4, fontSize: 11 }}
            labelStyle={{ color: '#94a3b8' }}
            formatter={(value) =>
              typeof value === 'number' ? value.toFixed(2) : (value ?? '')
            }
          />
          <Line type="monotone" dataKey="Q" stroke={COLORS.q} strokeWidth={1.5} dot={false} connectNulls />
          <Line type="monotone" dataKey="V" stroke={COLORS.v} strokeWidth={1.5} dot={false} connectNulls />
          <Line type="monotone" dataKey="Composite" stroke={COLORS.composite} strokeWidth={2} dot={false} connectNulls />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
